import { request } from '@/utils/request';

// 获取会员权益
export const getMemberRightListForMobile = data => {
	return request({
		url: '/user/public/memberLedger/getMemberRightListForMobile',
		method: 'POST',
		data: data,
	});
};

// 获取会员核销数据
export const queryRecordListForMobile = data => {
	return request({
		url: '/user/public/memberWriteoffRecord/queryRecordListForMobile',
		method: 'POST',
		data: data,
	});
};

// 意向登记列表
export const registrationAddWx = data => {
	return request({
		url: '/user/public/registration/addWx',
		method: 'POST',
		data: data,
	});
};

// 投诉建议提交
export const submitComplaintSuggestionsForMobile = data => {
	return request({
		url: '/user/public/memberComplaintSuggestions/submitComplaintSuggestionsForMobile',
		method: 'POST',
		data: data,
	});
};

// 获取资质证照
export const getLicenseByCompanyId = data => {
	return request({
		url: '/user/public/getLicenseByCompanyId',
		method: 'GET',
		data: data,
	});
};
// 添加意向客户
export const addPotentialCustomer = params => {
	return request({
		url: `/user/public/addPotentialCustomer`,
		method: 'POST',
		data: params,
	});
};

// 获取用户积分
export const getUserPointsOne = data => {
	return request({
		url: '/user/mall/userPoints/getUserPointsOne',
		method: 'POST',
		data: data,
	});
};

// 获取用户积分明细
export const getUserPointsDetailList = data => {
	return request({
		url: '/user/mall/userPointsDetail/getUserPointsDetailList',
		method: 'POST',
		data: data,
	});
};

// 获取用户兑奖记录
export const getPrizeWinningRecordList = data => {
	return request({
		url: '/user/mall/prizeWinningRecord/getPrizeWinningRecordList',
		method: 'POST',
		data: data,
	});
};

// 更新奖品中奖记录（填写收货地址）
export const updatePrizeWinningRecord = data => {
	return request({
		url: '/user/mall/prizeWinningRecord/updatePrizeWinningRecord',
		method: 'POST',
		data: data,
	});
};
// 确认登录接口
export const confirmLogin = data => {
	return request({
		url: '/sso/openIdLogin',
		method: 'POST',
		data,
	});
};

export const userLogging = data => {
	return request({
		url: '/sso/logging',
		method: 'POST',
		data,
	});
};
